

const baseUrl="https://api.weatherapi.com/v1/current.json?key=ae9efb85e1834f32a90171626250305";

export const weatherApi =async (city)=>{
    
   
    const result =await fetch(`${baseUrl}&q=${city}&aqi=yes`);
    return await result.json();
}